import { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { animatePresenceConfig } from "../../../../config/appConfig";
import { AnimatePresence, motion } from "framer-motion";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

export const LandingTestimonials = ({ testimonials }) => {
  const card = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const goToNextCard = i => {
    let nextIndex = i + 1;

    if (nextIndex >= testimonials.length) nextIndex = 0;
    setActiveIndex(nextIndex);
  };
  const goToPrevCard = i => {
    let prevIndex = i - 1;

    if (prevIndex < 0) prevIndex = testimonials.length - 1;
    setActiveIndex(prevIndex);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      goToNextCard(activeIndex);
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, [activeIndex]);

  return (
    <section className="section-layout">
      <div className="LandingTestimonials">
        {testimonials.map((testimonial, index) => {
          return (
            <>
              {index === activeIndex && (
                <AnimatePresence>
                  <motion.div {...animatePresenceConfig} transition={{ duration: 1.0 }}>
                    <div
                      className={clsx("LandingTestimonials-testimonial", `index-${index}`)}
                      key={index}
                      ref={card}
                    >
                      <div className="LandingTestimonials-testimonial-content">
                        {testimonial?.quote && <h4>{`“${testimonial?.quote.trim()}”`}</h4>}
                        {testimonial?.author_name && <p>&mdash; {testimonial?.author_name}</p>}
                        {testimonial?.author_title && <p>{testimonial?.author_title}</p>}
                        {testimonials.length > 1 && (
                          <div className="LandingTestimonials-testimonial-toggles">
                            <button
                              aria-label="Previous testimonial"
                              onClick={() => {
                                goToPrevCard(activeIndex);
                              }}
                            >
                              <FiArrowLeft />
                            </button>
                            <button
                              aria-label="Next testimonial"
                              onClick={() => {
                                goToNextCard(activeIndex);
                              }}
                            >
                              <FiArrowRight />
                            </button>
                          </div>
                        )}
                      </div>
                      {testimonial?.show_image && testimonial?.image && (
                        <div
                          className="LandingTestimonials-testimonial-image"
                          style={{ backgroundImage: `url(${testimonial?.image}` }}
                          aria-label={testimonial?.image_alt}
                        />
                      )}
                    </div>
                  </motion.div>
                </AnimatePresence>
              )}
            </>
          );
        })}
      </div>
    </section>
  );
};
